// chartDefaults — deterministic premium styling every created chart gets
// in CODE, not prompt. Office's factory chart (grey border, heavy default
// gridlines, thin bars, small doughnut hole, raw axis numbers) is the
// single biggest "pasted-on clip-art" signal on an otherwise styled
// dashboard canvas. These defaults cost zero prompt tokens and zero model
// round-trips; the model still owns palette, titles, and legend.
//
// Pure decision logic (unit-testable); the Office.js glue in office.ts
// applies the result, API-gating the ExcelApi 1.8 pieces.

export interface PremiumChartDefaults {
  // Remove the chart-area border so the chart sits flat on the canvas.
  borderNone: true;
  // Soften value-axis gridlines from Office's default grey to a whisper.
  gridlineColor: string;
  // Thick modern bars (Office default gap ~150% reads as thin sticks).
  gapWidth?: number;
  // Modern donut proportions.
  doughnutHoleSize?: number;
  // Value-axis number format inherited from the data labels, so the axis
  // never shows raw 743917.9 next to formatted labels.
  axisNumberFormat?: string;
}

const SOFT_GRIDLINE = '#E8EAED';

export function premiumChartDefaults(
  chartTypeLower: string,
  spec: { data_label_number_format?: string },
): PremiumChartDefaults {
  const sliced = chartTypeLower.includes('pie')
    || chartTypeLower.includes('doughnut') || chartTypeLower.includes('donut');
  const barLike = chartTypeLower.includes('column') || chartTypeLower.includes('bar');
  const d: PremiumChartDefaults = {
    borderNone: true,
    gridlineColor: SOFT_GRIDLINE,
  };
  if (barLike) d.gapWidth = 80;
  if (chartTypeLower.includes('doughnut') || chartTypeLower.includes('donut')) {
    d.doughnutHoleSize = 65;
  }
  if (!sliced && spec.data_label_number_format) {
    d.axisNumberFormat = spec.data_label_number_format;
  }
  return d;
}
